import React from 'react';
import useTripStore from '../../context/TripStore';

const TravelModeSelector = () => {
  const travelMode = useTripStore((state) => state.settings?.travelMode || 'WALKING');
  const setTravelMode = useTripStore((state) => state.setTravelMode);
  const currentStep = useTripStore((state) => state.ui?.currentStep || 'setup');

  // Only show on itinerary step
  if (currentStep !== 'itinerary') {
    return null;
  }

  const modes = [
    { value: 'WALKING', label: 'Walk', icon: '🚶' },
    { value: 'TRANSIT', label: 'Transit', icon: '🚇' },
    { value: 'DRIVING', label: 'Drive', icon: '🚗' },
    { value: 'BICYCLING', label: 'Bike', icon: '🚴' },
  ];

  return (
    <div className="fixed bottom-4 right-4 bg-white bg-opacity-95 backdrop-blur-sm border border-gray-200 rounded-lg shadow-lg z-30" style={{ pointerEvents: 'auto' }}>
      <div className="flex items-center gap-1 p-1">
        {modes.map((mode) => (
          <button
            key={mode.value}
            onClick={() => setTravelMode(mode.value)}
            className={`
              flex flex-col items-center justify-center px-3 py-2 rounded transition-colors
              ${travelMode === mode.value
                ? 'bg-gray-900 text-white'
                : 'text-gray-700 hover:bg-gray-100'
              }
            `}
            title={mode.label}
          >
            <span className="text-lg leading-none">{mode.icon}</span>
            <span className="text-xs font-light mt-0.5">{mode.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TravelModeSelector;



